import { FC, useMemo } from 'react'
import Figures, { FiguresProps } from 'src/components/Figures'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'

import { BlockProps } from '../props'

import { KeyStatisticBlockProps } from './props'

const KeyStatisticBlock: FC<BlockProps<KeyStatisticBlockProps>> = ({
  data,
}) => {
  const props: FiguresProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          richTextProps: { html: data.text || '' },
          actionButtonProps: ButtonTransformer({ data: data.cta }),
        },
      }),
      color: getThemeColor(data.theme?.data),
      cards: data.keyStat.map((stat) => ({
        data: [stat.mainStat, stat.secondaryNumber || ''],
        complement: stat.description,
      })),
    }),
    [data]
  )

  return <Figures {...props} />
}

export default KeyStatisticBlock
